import { IconButton } from "@mui/material"
import { Save } from "@mui/icons-material"
import PropTypes from "prop-types"
import { Component } from "react"
import "./style.scss"

export default class DeviceNameInput extends Component {
  static propTypes = {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    initialValue: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      value: props.initialValue,
    }
  }

  save = () => {
    const { value } = this.state
    const { initialValue, onCancel, onSave } = this.props

    if (value === initialValue || value === "") {
      onCancel()
    } else {
      onSave(value)
    }
  }

  onKeyDown = ev => {
    const { onCancel } = this.props
    if (ev.key === "Enter") {
      this.save()
    }

    if (ev.key === "Escape") {
      onCancel()
    }
  }

  onChange = ev => {
    this.setState({ value: ev.target.value })
  }

  render() {
    const { initialValue } = this.props
    const { value } = this.state

    return <div className="modules_user-profile_components_device-name-input">
      <input
        type="text"
        placeholder={initialValue}
        value={value}
        onChange={this.onChange}
        onKeyDown={this.onKeyDown}
        autoFocus
        maxLength="40"
      />
      <IconButton color="primary" onClick={this.save} size="large">
        <Save />
      </IconButton>
    </div>
  }
}
